import React from "react";
import { useLogoutMutation } from "src/features/auth/store/auth.api-slice";
import { Navigate } from "react-router-dom";
import { FaPowerOff } from "react-icons/fa";

interface LogoutProps {
  isCollapsed?: boolean;
}

export default function Logout({ isCollapsed = false }: LogoutProps) {
  const [logout, logoutResult] = useLogoutMutation();

  let logoutHanlder = () => {
    logout();
  };

  return (
    <>
      <button
        onClick={logoutHanlder}
        className={`font-bold border border-gray-300 bg-white hover:bg-gray-100 text-gray-700 rounded-md text-sm transition-colors group ${
          isCollapsed 
            ? "p-2 flex items-center justify-center" 
            : "px-3 py-[5px]"
        }`}
        title={isCollapsed ? "Logout" : undefined}
      >
        {isCollapsed ? (
          <FaPowerOff className="w-4 h-4" />
        ) : (
          "Logout"
        )}
      </button>
      {logoutResult.isSuccess ? <Navigate to={"/login"} /> : null}
    </>
  );
}
